var FUTURE_TOKENS = {
  AVATAR_USER_CIRCLE_HOVER_BACKGROUND_COLOR: "rgba(53, 59, 65, 0.5)",
  BADGE_ERROR_VARIANT_BACKGROUND_COLOR: "rgb(231, 29, 50)",
  BUTTON_ERROR_VARIANT_ACTIVE_COLOR: "rgb(189, 20, 38)",
  BUTTON_ERROR_VARIANT_HOVER_COLOR: "rgb(189, 20, 38)",
  BUTTON_GHOST_VARIANT_ACTIVE_COLOR: "rgba(207, 212, 218, 0.4)",
  BUTTON_GHOST_VARIANT_HOVER_COLOR: "rgba(207, 212, 218, 0.4)",
  BUTTON_TAG_DANGER_BACKGROUND_ACTIVE_COLOR: "rgba(231, 29, 50, 0.4)",
  BUTTON_TAG_DANGER_BACKGROUND_COLOR: "rgba(231, 29, 50, 0.2)",
  BUTTON_TAG_DANGER_BACKGROUND_HOVER_COLOR: "rgba(231, 29, 50, 0.4)",
  BUTTON_TAG_SUCCESS_BACKGROUND_ACTIVE_COLOR: "rgba(0, 138, 31, 0.4)",
  BUTTON_TAG_SUCCESS_BACKGROUND_COLOR: "rgba(0, 138, 31, 0.2)",
  BUTTON_TAG_SUCCESS_BACKGROUND_HOVER_COLOR: "rgba(0, 138, 31, 0.4)",
  BUTTON_TERTIARY_VARIANT_ACTIVE_COLOR: "rgb(244, 245, 245)",
  MODAL_FULLSCREEN_BACKGROUND_COLOR: "rgba(84, 91, 100, 0.75)",
  CONTENT_CHIP_ACTION_CONTAINER_BACKGROUND_COLOR: "rgba(255, 255, 255, 0.9)",
  CONTENT_CHIP_ACTION_CONTAINER_SELECTED_BACKGROUND_COLOR: "rgba(230, 230, 244, 0.9)",
  FOLDER_CARD_ACTIONS_BACKGROUND_COLOR: "rgba(255, 255, 255, 0.8)",
  LIST_ITEM_BACKGROUND_COLOR: "rgba(207, 212, 218, 0.4)",
  DROP_SHADOW_COLORS: {
    PARAMETERS_0_8_8: "rgba(83, 91, 100, 0.08)",
    PARAMETERS_0_8_16: "rgba(83, 91, 100, 0.24)",
    PARAMETERS_0_16_24: "rgba(83, 91, 100, 0.32)",
    PARAMETERS_0_24_32: "rgba(83, 91, 100, 0.32)"
  },
  CONTENT_CARD_OVERLAY_BACKGROUND_COLOR: "rgba(52, 58, 64, 0.5)",
  CONTENT_CARD_BASE_OVERLAY_BACKGROUND_COLOR: "rgba(207, 212, 218, 0.36)",
  CONTENT_CARD_CHECKBOX_DROP_SHADOW_COLOR: "rgba(52, 58, 64, 0.4)"
};

export { FUTURE_TOKENS };
